import { dictionary, Language } from "./dictionary";

/** Clave de dictionary por estado canónico de envío (backend FulfillmentStatus). */
const FULFILLMENT_STATUS_KEYS: Record<string, string> = {
  PENDING: "fulfillment-status-pending",
  GUIDE_GENERATED: "fulfillment-status-guide-generated",
  PICKED_UP: "fulfillment-status-picked-up",
  IN_TRANSIT: "fulfillment-status-in-transit",
  INCIDENT: "fulfillment-status-incident",
  OUT_FOR_DELIVERY: "fulfillment-status-out-for-delivery",
  DELIVERED: "fulfillment-status-delivered",
  RETURNED: "fulfillment-status-returned",
  CANCELED: "fulfillment-status-canceled",
};

/** Label traducido de un estado de envío; estados desconocidos vuelven tal cual. */
export const fulfillmentStatusLabel = (status: string | null | undefined, language: Language): string => {
  if (!status) return "—";
  const key = FULFILLMENT_STATUS_KEYS[status];
  return key ? dictionary[key][language] : status;
};

export type OrderProvider = "dropi" | "mastershop" | "shopify";

export const PROVIDER_NAMES: Record<OrderProvider, string> = {
  dropi: "Dropi",
  mastershop: "Mastershop",
  shopify: "Shopify",
};

/**
 * Proveedor que TIENE la orden (despachada o en vuelo), o null si la despacha el propio comercio.
 * El que despacha es el dueño del estado: él sabe la verdad del envío, y su API no acepta que le
 * empujemos un estado de vuelta.
 *
 * Un intento FALLIDO no hace dueño: si Dropi respondió 503, la orden no está en Dropi y decir
 * "lo actualiza Dropi" sería falso (pasa en embudos que tuvieron dos proveedores activos: Dropi
 * falla, Mastershop la despacha, y la dueña es Mastershop).
 *
 * Espeja `OrderProviderOwnership.owners` del backend, que es quien realmente rechaza el cambio
 * manual; esto solo evita ofrecer algo que el backend va a negar.
 */
const providerHasOrder = (state?: string | null): boolean =>
  !!state && !state.trim().toUpperCase().startsWith("ERROR");

export const owningOrderProvider = (order: {
  dropi_state?: string | null;
  mastershop_state?: string | null;
  shopify_integration_state?: string | null;
}): OrderProvider | null => {
  if (providerHasOrder(order.dropi_state)) return "dropi";
  if (providerHasOrder(order.mastershop_state)) return "mastershop";
  if (providerHasOrder(order.shopify_integration_state)) return "shopify";
  return null;
};
